/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsBoolResponse
 */
export interface MelcoModelsBoolResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MelcoModelsBoolResponse
     */
    result?: boolean;
}

export function MelcoModelsBoolResponseFromJSON(json: any): MelcoModelsBoolResponse {
    return MelcoModelsBoolResponseFromJSONTyped(json, false);
}

export function MelcoModelsBoolResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsBoolResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function MelcoModelsBoolResponseToJSON(value?: MelcoModelsBoolResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
    };
}


